import React from "react";

interface ProductSkeletonProps {
  style?: React.CSSProperties;
}

const ProductSkeleton: React.FC<ProductSkeletonProps> = ({ style }) => {
  return (
    <div
      style={style}
      className="mx-2 my-1 bg-white dark:bg-dark-800 rounded-xl border border-gray-100 dark:border-dark-700 overflow-hidden animate-pulse"
    >
      <div className="p-4">
        <div className="flex items-start space-x-3">
          {/* Product Image Skeleton */}
          <div className="w-16 h-16 bg-gray-200 dark:bg-dark-700 rounded-lg flex-shrink-0"></div>

          {/* Product Content Skeleton */}
          <div className="flex-1 space-y-3">
            {/* Product Name Skeleton - Multiple lines for realism */}
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 dark:bg-dark-700 rounded w-4/5"></div>
              <div className="h-3 bg-gray-200 dark:bg-dark-600 rounded w-2/3"></div>
            </div>

            {/* Price and Status Skeleton */}
            <div className="flex items-center space-x-3">
              <div className="h-5 bg-gray-300 dark:bg-dark-600 rounded w-20"></div>
              <div className="h-4 bg-gray-100 dark:bg-dark-700 rounded w-16"></div>
            </div>

            {/* Action Buttons Skeleton */}
            <div className="flex space-x-2 pt-1">
              <div className="h-7 bg-gray-100 dark:bg-dark-700 rounded-lg w-20"></div>
              <div className="h-7 bg-gray-100 dark:bg-dark-700 rounded-lg w-24"></div>
            </div>
          </div>

          {/* Action Button Skeleton */}
          <div className="w-8 h-8 bg-gray-200 dark:bg-dark-700 rounded-full"></div>
        </div>
      </div>
    </div>
  );
};

export default ProductSkeleton;
